import React from 'react';
import { uuidv4, capitalizePhrase, capitalize, isJSON } from '../../libraries/utils';
import { useTranslation } from 'react-i18next';
import Avatar from '../commons/Avatar';


export default function UserMessageHeader({ professional, points, left, ...rest }) {
  const { t } = useTranslation();  
  const { specialty, fantasy_name } = isJSON(professional.json_data) ? JSON.parse(professional.json_data) : professional.json_data;
  const { profile_image, username, name} = professional;
  return (
      <div key={rest.key || uuidv4()} className="flex justify-center w-full">
        <Avatar
          image={profile_image}
          label={username}
          className="rounded-full w-16 h-16"
          containerClassName="mr-3"
        />
        <div className="flex flex-col justify-center items-start">
            <div className='mb-1'>
                {(name || fantasy_name) && 
                <h3 className="text-white text-lg">{capitalizePhrase(fantasy_name || name)}</h3>
                
                } 
            </div>
            <div className='mb-1'>
                {specialty && (
                <small className='flex text-left opacity-80'>{capitalize(t(specialty))}</small>
                )}
            </div>
        </div>
      </div>
  )
}